module.exports = __webpack_public_path__ + "fonts/dmsans-medium-webfont.5c49173.woff";